import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssRadioColorDefault = css`
`;

export const radioColorVariants = {
  default: CssRadioColorDefault,
};

export type IRadioColorVariants = VariantOfType<typeof radioColorVariants>;
